import React from 'react';
import { Sun, Moon } from 'lucide-react';
import useTheme from '../../utils/useTheme';

export default function ThemeToggle() {
  const { isDark, toggle } = useTheme();
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';

  return (
    <div
      className="home-logout theme-toggle"
      onClick={toggle}
      role="button"
      tabIndex={0}
      aria-label={label}
      title={label}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      }}
    >
      {isDark ? <Sun size={18} strokeWidth={1.75} /> : <Moon size={18} strokeWidth={1.75} />}
    </div>
  );
}
